export enum FieldType {
  INPUT = 'input',
  TEXTAREA = 'textarea',
  RADIO = 'radio',
  DATE_TIME = 'datetime',
  SELECT = 'select',
  CHECKBOX = 'checkbox',
  TOGGLE = 'toggle',
  SLIDER = 'slider',
}
